export const PASSWORD_MIN_LENGTH = 8;
export const PASSWORD_REGEX = new RegExp(
  '^(?!.*\\s)(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9]).*[!@#$%^&*+=\\\\?\\-<>|(){}\'\\";:/€].*'
);
export const INTERVAL_DELAY = 100;

export const SEARCH_INPUT_DEBOUNCE_TIME = 500;

export const MAX_PENDING_OFFERS = 10;
